var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{staticClass:"ma-auto",attrs:{"indeterminate":"","size":60,"color":"grey darken-1"}})}
var staticRenderFns = []

export { render, staticRenderFns }